import request from '@/utils/request'

export function getItemDetailList() {
  return request({
    url: '/api/purchaseOrderBase/queryListByAcceptOrderBaseId',
    method: 'get',
  })
}

export function getDataByItemDetailCd(data) {
  return request({
    url: '/api/purchaseOrderBase/getDataByItemDetailCd',
    method: 'get',
    params: data,
  })
}

export function getDataBySupplierCd(data) {
  return request({
    url: '/api/purchaseOrderBase/getDataBySupplierCd',
    method: 'get',
    params: data,
  })
}

export function getDirectOrderDetail(data) {
  return request({
    url: '/api/order/getDirectOrderDetail',
    method: 'post',
    data,
  })
}

export function getChangeHistory(data) {
  return request({
    url: '/api/purcharseOrder/changeHistory',
    method: 'post',
    data,
  })
}

export function getDataByPurchaseOrderDetail(data) {
  return request({
    url: '/api/purchaseOrderBase/order-detail',
    method: 'get',
    params: {
      itemDetailCd: data,
    },
  })
}

export function getDataByPurchaseOrderDep() {
  return request({
    url: '/api/purchaseOrderBase/purchaseOrderDep',
    method: 'get',
  })
}

export function getPurcharseOrderDetailList() {
  return request({
    url: '/api/purcharseOrder/orderDetailList',
    method: 'get',
  })
}
